import { Box, Skeleton } from '@hopskipdrive/react-components';

import {
  AuthorizedContactGroupContainer,
  ContactGroupFlexRow,
  ContactGroupFormContainer,
  Container,
  ProtocolContainer,
} from './MustBeMetProtocolForm.styles';

export const MustBeMetProtocolSkeleton = ({ groupCount = 1 }: { groupCount?: number }) => (
  <Container role="status" aria-label="Loading must-be-met instructions" aria-busy="true">
    <ProtocolContainer>
      <Box>
        <Skeleton width={125} height={40} />
        <Skeleton variant="rounded" width={200} height={40} />
      </Box>
      <Box>
        <Skeleton variant="rounded" height={67} />
      </Box>
    </ProtocolContainer>
    <AuthorizedContactGroupContainer>
      <Skeleton width={260} height={20} />
      <Skeleton width="70%" height={20} />
      {Array.from({ length: Math.max(1, groupCount) }, (_, index) => (
        <ContactGroupFormContainer key={index}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Skeleton width={240} height={24} />
            <Skeleton width={64} height={36} />
          </Box>
          <ContactGroupFlexRow>
            <Skeleton width={100} height={24} />
            <Skeleton variant="rounded" width="30%" height={40} />
            <Skeleton width={140} height={24} />
            <Skeleton variant="rounded" width="30%" height={40} />
          </ContactGroupFlexRow>
          <Box display="flex" flexDirection="column" gap={4}>
            <Skeleton width={190} height={24} />
            <Box display="flex" gap={4}>
              <Skeleton width={180} height={24} />
              <Skeleton width={180} height={24} />
              <Skeleton width={180} height={24} />
            </Box>
          </Box>
        </ContactGroupFormContainer>
      ))}
      <Skeleton width={220} height={36} />
    </AuthorizedContactGroupContainer>
  </Container>
);
